module.exports = __webpack_public_path__ + "img/dep_computerphoneandelectronics@2x.05cb2360.png";